/* eslint max-len: off */
/*
We have the following problem with url encoding-decoding here:

The link here looks something like this, e.g: https://app.getsquire.com/app-login/123?username=test@getsquire.com
1. Backend encodes username when it makes this URL and sends it as magic sign in button url.
E.g. email '?username=test+user@getsquire.com' would be sent as 'https://app.getsquire.com/app-login/123?username=test%2Buser%40getsquire.com'

2. then this url is automatically wrapped into a tracking url by mailchimp (?). E.g. something like
'https://stuff.awstrack.me/L0/https:%2F%2Fapp.getsquire.com%2Fapp-login%2F123%3Fusername=jean%2Btest-email_encoding.here%40getsquire.com'

3. then when the user clicks the link, this tracker automatically unwraps the link back and redirects the user. But the special symbols get un-encoded in the process:
https://app.getsquire.com/app-login/123?username=test+user@getsquire.com

4. Which then by javascript url param parser is interpreted as '+' being equal to ' ', because '+' is not encoded anymore :(

Since we know it's an email, and emails can only have +-._ as special symbols in them, and only '+' shows weird behavior,
I'm going to solve it by this dirty replacement hack and hope that it works
 */
export var getUsername = function (username) { return username === null || username === void 0 ? void 0 : username.replace(' ', '+'); };
export var putLoginLinkToPasteboard = function (loginToken, username) {
    var _a;
    try {
        var payload = JSON.stringify({ loginToken: loginToken, username: username });
        (_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText("461938 https://squire.commander ".concat(payload));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        // do nothing just be sad
    }
};
